<template lang="pug">
.v-calculator.calculator(v-if="data")
	h3.detail-page__calculator-title(v-if="data.title") {{ data.title }}
	.calculator__fields(v-if="data.fields")
		.calculator__field(v-for="(field, index) in data.fields" :key="index" )
			v-field(:field="field" v-model="field.value" @update:model-value="fieldChanged(field)")
	.calculator__results(v-if="data.results")
		h4.calculator__results-title(v-if="data.results.title") {{ data.results.title }}
		.calculator__results-table(v-if="data.results.items")
			.calculator__result-row(v-for="(result, index) in data.results.items" :key="index" )
				.calculator__result-text(v-if="result.text" ) {{ result.text }}
				.calculator__result-number(v-if="result.id")
					| {{ calculator(localValue.length, localValue.height, localValue.thickness, localValue.windowsArea, localValue.size, result.id) }}
		.calculator__results-note(v-if="data.results.note" v-html="data.results.note" )


</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';

export default {

	mixins: [
		sourceMixin
	],

	data() {
		return {
			data: null,
			modelValue: null,
			localValue: {
				length: '',
				height: '',
				windowsArea: '',
				thickness: '',
				size: ''
			}
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;
			if(this.data && this.data.fields) {
				this.data.fields.forEach(field => this.localValue[field.id] = String(field.value))
			}
		},

		fieldChanged(field) {
			this.localValue[field.id] = String(field.value)
		},

		numberWithSpaces(x) {
			let parts = x.toString().split(".");
			parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
			return parts.join(",");
		},

		customRound(number, onlyRound) {
			if (onlyRound !== undefined && onlyRound) {
				return this.numberWithSpaces(Math.round(number));
			}

			let numb = number;
			let decimals = 0;
			if (Math.ceil(numb) - numb > 0) {
				numb *= 10;
				decimals += 1;

				if (Math.ceil(numb) - numb > 0) {
					numb *= 10;
					decimals += 1;
				}
			}

			return this.numberWithSpaces(number.toFixed(decimals));
		},

		calculator(length, height, thickness, windowsArea, size, id) {
			length = String(length).replace(',', '.');
			height = String(height).replace(',', '.');

			let itemLength,
				itemWidth,
				itemHeight,
				price,
				thicknessW;

			const thicknessR = 10;
			const density = 1280;
			const densityR = 1900;

			[itemLength, itemWidth, itemHeight] = size.split('*').map(item => Number(item));

			price = 0.48;

			switch (thickness) {
				case '0.5':
					thicknessW = itemWidth;
					break;
				case '1':
					thicknessW = itemLength;
					break;
				case '1.5':
					thicknessW = itemWidth + itemLength + thicknessR;
					break;
				case '2':
					thicknessW = itemLength * 2 + thicknessR;
					break;
			}


			let itemLength2 = itemLength + thicknessR;
			let itemWidth2 = itemWidth + thicknessR * thickness * 0.4;
			let itemHeight2 = itemHeight + thicknessR;
			let volume = itemLength / 1000 * itemWidth / 1000 * itemHeight / 1000;
			let volume2 = itemLength2 / 1000 * itemWidth2 / 1000 * itemHeight2 / 1000;
			let countM3wo = 1 / volume;
			let countM3wh = 1 / volume2;
			let spaceK = (length * height) - windowsArea;
			let volumeK = spaceK * thicknessW / 1000;
			let countM3woK = countM3wo * volumeK;
			let countM3whK = countM3wh * volumeK;
			let weight = volume * density;
			let weightAll = weight * countM3whK;
			let volumeAll = volume * countM3whK;
			let volumeR = volumeK - volumeAll;
			let weightR = volumeR * densityR;
			let weightW = weightAll + weightR;
			let spaceW = volumeK / height * 10000;

			let result = {
				'weight': this.customRound(weight), // Вес кирпича,
				'countM3wo': this.customRound(countM3wo, true), // Количество кирпича в 1м3 (без учета швов)
				'countM3wh': this.customRound(countM3wh, true), // Количество кирпича в 1м3 (с учетом швов)
				'countM3woK': this.customRound(countM3woK, true), // Кол-во кирпича в кладке (без учета швов)
				'countM3whK': this.customRound(countM3whK, true), // Кол-во кирпича в кладке (с учетом швов)
				'weightAll': this.customRound(weightAll), // Общий вес кирпича
				'densityR': this.customRound(densityR), // Плотность раствора
				'thicknessR': this.customRound(thicknessR), // Толщина раствора
			};

			return result[id] || 0
		}
	},


}

</script>